import {SearchDisplayContext, SearchSortOption} from 'common/report/util/search/types';

export enum ShareStatusFilter {
  Shared = `Shared with you`,
  Owner = `Created by you`,
}

export enum FilterType {
  CreatorEmail = `creator-email`,
  ShareStatus = `share-status`,
  Report = `report`,
  Event = `event`,
}

export type SearchFilter = {
  [FilterType.CreatorEmail]?: string[];
  [FilterType.ShareStatus]?: ShareStatusFilter[];
  [FilterType.Report]?: SearchDisplayContext[];
  [FilterType.Event]?: string[];
};

export type BrowseQueryParams = {
  filter: SearchFilter;
  sort: SearchSortOption;
};

export enum BrowseMode {
  Add = `add`,
  Browse = `browse`,
  Discover = `discover`,
}
